import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Rx';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class FormService {

  /* UI related properties */
  theme:string = 'vodafone';
  screen:string = 'start';
  isIntro:boolean = true;
  didSubmit:boolean = false;
  didFail:boolean = false;
  isLive:boolean = false;

  /* Customer fields */
  uuid:any = false;
  selectedRange:number = 0;
  selectedCategory:string;
  feedback:string;
  campaignId:string;
  requestBody:any = {};

  constructor(
    private http: Http,
    private router: Router
  ) { }

  submit() {

    if (!this.didSubmit) {
      switch (this.theme) {
        case "vodafone":
          this.submitToVodafone();
          break;
        case "ziggo":
          this.submitToZiggo();
          break;
      }
    }

  }

  submitToVodafone() {

    this.requestBody = {
      HashedID : this.uuid,
      CampaignID : this.campaignId,
      LIST_ID : this.isLive ? 641381 : 641444,
      Emoij : this.getEmoji(),
      Category : this.selectedCategory,
      ExplanationText : this.removeEnter(),
      VISIT : this.getVisit(),
      VFZG: 'VF'
    }

    this.doRequest('/rest/marketing-form/', this.requestBody)
     .subscribe(
       result => {
         this.finishedRequest();
       },
       error => {
         this.didFail = true;
       }
     );
  }

  /* Ziggo specific request */
  submitToZiggo() {


    console.log(this.feedback);

    let requestBody = new FormData();

    /* Required fields (dummy data) */
    requestBody.append('zipcode',     'nvt');
    requestBody.append('housenumber', 'nvt');
    //requestBody.append('VISIT', new Date().getTime());
    //requestBody.append('Dont_Call', '0');
    requestBody.append('Extra1', 'nvt');
    requestBody.append('Extra2', 'nvt');

    /* Actual data */
    requestBody.append('HashedID', this.uuid);
    requestBody.append('CampaignID', this.campaignId);
    requestBody.append('LIST_ID', this.isLive ? 641444 : 641444);
    requestBody.append('Emoij', this.getEmoji());
    requestBody.append('Category', (typeof this.selectedCategory != "undefined") ? this.selectedCategory : '');
    requestBody.append('ExplanationText', (typeof this.feedback != "undefined") ? this.feedback : '');
    requestBody.append('VFZG', 'ZG');

    this.doRequest('https://restapi.ziggo.nl/1.0/ibmmc/', requestBody)
     .subscribe(
       result => {
         this.finishedRequest();
       },
       error => {
         this.didFail = true;
       }
     );
  }

  /* Mark form as saved and show result screen (when unhappy) */
  private finishedRequest() {
    this.didSubmit = true;
    if (this.selectedRange > 2) this.screen = 'result';
  }

  /* Make the request or return a mock Observable */
  private doRequest(requestURL:string, requestBody:any) {
    if (requestURL == null) {
      return Observable.of(new Object());
    }
    return this.http.post(requestURL, requestBody)
      .map(res => res.json())
      .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
  }

  /* Determine which emoji name to send from range */
  private getEmoji() {
    let emoji:string;
    switch (this.selectedRange) {
      case 1:
        emoji = 'happy';
        break;
      case 2:
        emoji = 'satisfied';
        break;
      case 3:
        emoji = 'neutral';
        break;
      case 4:
        emoji = 'couldbebetter';
        break;
      case 5:
        emoji = 'unhappy';
        break;
    }
    return emoji;
  }

  /* Capture the time of the visit */
  private getVisit() {
    var visitDate = new Date ();
    var visitTime = visitDate.getTime();

    return visitTime;
  }

  private removeEnter() {
    if (this.feedback) {
      var feedbackOrigin = this.feedback;
      var feedbackEdit = feedbackOrigin.replace(/\r?\n/g, ' ');

      return feedbackEdit;
    }
  }
}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/form.service.ts